import { render, staticRenderFns } from "./TestDetailsModal.vue?vue&type=template&id=2d2852e0&"
import script from "./TestDetailsModal.vue?vue&type=script&lang=js&"
export * from "./TestDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./TestDetailsModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports